export default (message: string = 'Please enter your full name.') => (value: string): string | boolean => {
  if (!value) {
    return true;
  }
  const names = value.trim().split(/ +/g);
  return names.length >= 2 || message;
};
